// extracted by mini-css-extract-plugin
export default {"reactionsContainer":"Tbl_BB"};